import { render, staticRenderFns } from "./registrationInformation.vue?vue&type=template&id=4367a123"
import script from "./registrationInformation.vue?vue&type=script&lang=js"
export * from "./registrationInformation.vue?vue&type=script&lang=js"
import style0 from "./registrationInformation.vue?vue&type=style&index=0&id=4367a123&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports